var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecondaryHandCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.38,
    height: 84.38,
    viewBox: "0 0 84.38 84.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.869 -13.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.869 13.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.94,41.88A42.19,42.19,0,0,0,63.13-.31,42.19,42.19,0,0,0,20.94-42.5,42.19,42.19,0,0,0-21.25-.31,42.19,42.19,0,0,0,20.94,41.88",
    transform: "translate(21.25 42.5)",
    fill: "#fcaa3c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.133 30.775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.062,16.688l-1.1-.133a1.243,1.243,0,0,1-.911-.584L13.208,6.455a4,4,0,0,0-3.633-1.9l-7.153.4A4.006,4.006,0,0,0-1.361,8.911L-1.385,11.8c0,.05,0,.1-.008.147l-.445,4.481a1.6,1.6,0,0,0,1.67,1.757l.87-.042a4,4,0,0,0,3.657-2.881l.661-2.279a1.6,1.6,0,0,0-.564-1.717l-.232-.179m8.025,10.408c-4.8-1.6-6.568-7.283-7.167-9.226M18.2,30.969l-1.445-.353a4,4,0,0,0-2.527.208l-1.042.447a11.206,11.206,0,0,1-6.872.633L-6.6,29.006M-.559,6.28l-3.169-.929A2.881,2.881,0,0,0-7.311,7.335l0,0a2.916,2.916,0,0,0,2.013,3.6l3.369.949M-10.6,19.09a2.914,2.914,0,0,0,2.1,3.175l5.609,1.582a2.914,2.914,0,0,0,3.6-2.013,2.914,2.914,0,0,0-2.013-3.6l-6.727-1.96a2.914,2.914,0,0,1-2.013-3.6m.308,12.931h0a2.912,2.912,0,0,0,2.474,3.3l4.37.623A2.911,2.911,0,0,0,.4,27.06,2.909,2.909,0,0,0-.7,24.34m28.965-7.652-4.819-1.205a1.6,1.6,0,0,0-1.95,1.2L18.221,30.358a1.6,1.6,0,0,0,1.169,1.926l1.666.417M-2.961,5.48A34.484,34.484,0,0,1-.378-16.935l17.43,6.4s-3.2,4.8-5.883,15.212M.241-1.725c0-1.6,0-5.6,1.485-8.005a2.453,2.453,0,0,0,2.1-1.6l6.312,2.4a3.126,3.126,0,0,0,.7,3.2,22.276,22.276,0,0,0-2.1,5.6m-1.445,4A3.361,3.361,0,0,0,3.829.676C1.506.676.241,2.248.241,4.68v.8m-5.6-20.015-8.805.8S-4.563-4.127-4.563,4.68m-6.4-14.41-10.408,4A18.236,18.236,0,0,1-4.563,4.68",
    transform: "translate(21.374 16.935)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondaryHandCash);
export default __webpack_public_path__ + "static/media/secondary-hand-cash.8377302d31c75bbad22ba28696696d93.svg";
export { ForwardRef as ReactComponent };